// extracted by mini-css-extract-plugin
export default {"mechanicList":"mechanic_cadastre_list_mechanicList__POo2w","Mui-focused":"mechanic_cadastre_list_Mui-focused__AkApL","label":"mechanic_cadastre_list_label__x9JYI"};